function SkillSlot(item){

  return <div className="itemSlot slot">{item}</div>
}

export default SkillSlot;